import { FC } from "react";
import { Box, Typography } from "@mui/material";
import CastConnectedIcon from "@mui/icons-material/CastConnected";
import { useTranslation } from "@/shared/hooks";

interface CastOverlayProps {
  deviceName: string | null;
  poster?: string | null;
}

/**
 * Заглушка на месте локального видео, пока идёт каст этого же ролика на
 * внешнее устройство — управление всё равно остаётся в общем PlayerFooter
 * (Player.tsx подменяет ему состояние/экшены на удалённые), здесь только
 * визуальный статус, без своих контролов.
 */
export const CastOverlay: FC<CastOverlayProps> = ({ deviceName, poster }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#000",
        backgroundImage: poster ? `url(${poster})` : undefined,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.7)",
        }}
      />
      <CastConnectedIcon sx={{ fontSize: 56, color: "#fff", zIndex: 1 }} />
      <Typography sx={{ color: "#fff", zIndex: 1, textAlign: "center", px: 2 }}>
        {deviceName
          ? t("player.cast.playingOn", { device: deviceName })
          : t("player.cast.playing")}
      </Typography>
    </Box>
  );
};
